export const SET_SELECTED_SEGMENTATION = "SET_SELECTED_SEGMENTATION";
export const SET_VIEWER_ORIENTATION = "SET_VIEWER_ORIENTATION";

// action creators
export const setSelectedSegmentation = function (seg) {
    return {
        type: SET_SELECTED_SEGMENTATION,
        seg: seg,
    };
};

export function setViewerOrientation(orientation) {
    return {
        type: SET_VIEWER_ORIENTATION,
        orientation,
    };
}
